<template>
    <div class="li-fornecedor-proposta">
        <az-form>
            <div class="info-termo" style="display: flex; align-items: end;">
                <a @click="abrirModalTermo" style="margin-left: 1em; margin-right: 1em;">
                    <span>Licitante declarou-se Me/Epp/Mei: {{
                            propostaResumo.propostaTermo && propostaResumo.propostaTermo.microEmpresa === 'S' ? 'Sim' : 'Não'
                        }}</span>
                    Alterar
                </a>
            </div>
            <LicitacaoMensagemCerca v-if="!isPropostaEnviada" :ehCercaValido="propostaResumo.ehCercaValido"
                                    style="margin-top: 10px"/>
            <div v-if="this.pregaoUtilizaMoedaEstrangeira && this.moedasDisponiveis.length > 0"
                 style="display: flex; align-items: center; margin-top: 1em;">
                <div class="alert alert-info"
                     style="background-color: #d9edf7; color: #31708f; padding: 10px; border-radius: 4px;">
                    <strong>Attention!</strong> Exchange values for <strong>FOLLOW-UP</strong>, your proposal must be
                    <strong>SENT</strong> in <strong>REAL(R$)</strong>. In trading, the follow-up will be based on the
                    currency defined in the last shipment!
                </div>
                <v-select
                    v-model="moedaSelecionadaId"
                    :items="moedasDisponiveis"
                    item-text="descricao"
                    item-value="id"
                    label="Currency"
                    @change="onMoedaSelecionada"
                    :disabled="isPropostaEnviada"
                    style="margin-left: 2em;">
                </v-select>
            </div>

            <div v-if="this.pregaoUtilizaMoedaEstrangeira && this.moedaSelecionada.existeMoedaSelecionada"
                 style="display: flex; justify-content: flex-end">
              <span>
                Currency: {{ this.moedaSelecionada.sigla }}
                {{ this.moedaSelecionada.cotacaoVenda }}
                at {{ this.moedaSelecionada.dataReferencia }}
              </span>
            </div>

            <br/>

            <div class="proposta-periodicidade-contexto">
                <div class="proposta-prazos">
                    <div>
                        <v-text-field class="campo-prazo-validade" name="Prazo Entrega" label="Prazo Entrega *"
                                      placeholder="prazo em dias"
                                      v-model="prazoEntrega"
                                      @keypress="permitirApenasNumeros"
                                      v-if="!isPropostaEnviada"
                                      :disabled="isPropostaEnviada"
                                      @change="atualizarPrazo"
                        ></v-text-field>
                        <div class="az-text fornecedor-proposta-prazo-entrega" v-if="isPropostaEnviada && prazoEntrega != null">
                            <label>Prazo Entrega</label>
                            <p class="mb-0">{{ prazoEntrega }} {{ prazoEntrega > 1 ? " Dias" : " Dia" }}</p>
                        </div>
                    </div>
                    <div>
                        <v-text-field
                            name="Prazo Validade" label="Prazo Validade *" placeholder="prazo em dias"
                            class="campo-prazo-validade"
                            v-model="prazoValidade"
                            @keypress="permitirApenasNumeros"
                            v-if="!isPropostaEnviada"
                            :disabled="isPropostaEnviada"
                            @change="atualizarPrazo"
                        ></v-text-field>
                        <div class="az-text fornecedor-proposta-prazo-validade"
                             v-if="isPropostaEnviada && prazoValidade != null">
                            <label>Prazo Validade</label>
                            <p class="mb-0">{{ prazoValidade }} {{ prazoValidade > 1 ? " Dias" : " Dia" }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="possuiItemComPeriodicidade" class="aviso-periodicidade">
                    <v-icon color="#1687d4" class="aviso-periodicidade__icone">info_outline</v-icon>
                    <div>
                        <strong>Sobre a periodicidade</strong>
                        <p>Alguns itens possuem periodicidade. O valor informado será considerado para o período indicado.<br>
                            Essa informação é apenas orientativa e não altera o preenchimento da proposta.</p>
                    </div>
                </div>
            </div>
            <p v-if="!isPropostaEnviada" class="aviso-participacao">
                Senhor licitante, caso não queira mais participar de um item ou grupo específico,
                basta clicar no ícone de <strong>“X”</strong> para apagar o valor preenchido.
                Assim, o campo ficará com a palavra <em>“informe”</em>, indicando que você não
                está mais participando daquele item.
            </p>
            <br/>

            <v-data-table
                v-if="dataReady"
                :headers="headers"
                :items="licitacaoPropostaItens"
                :loading="false"
                class="az-table-list"
                sort-icon="mdi-menu-down"
                item-key="licitacaoLoteItemId"
                :rows-per-page-items="tablePaginationDropdown">
                <template slot="items" slot-scope="props">
                    <licitacao-fornecedor-proposta-item v-model="props.item"
                                                        @atualizarItemProposta="atualizarLoteItemProposta"
                                                        :moeda="moedaSelecionada"
                                                        :exibir-periodicidade="possuiItemComPeriodicidade"
                                                        v-if="formatacaoPreco"
                    />
                </template>
            </v-data-table>
            <div v-if="possuiItemComPeriodicidade" class="legenda-periodicidade">
                <v-icon color="primary">info_outline</v-icon>
                <div>
                    <div><strong class="legenda-periodicidade__titulo">Periódico:</strong> o valor total informado corresponde ao período indicado ao lado do item.</div>
                    <div>Exemplo: item com período de 10 meses e valor total de R$ 100.000,00 = valor médio mensal de R$ 10.000,00 (apenas informativo).</div>
                </div>
            </div>
        </az-form>
        <div class="az-actions-form" v-if="!isPropostaEnviada">
            <div class="align-left"></div>
            <div class="align-right" style="display: flex">
                <a class="action-primary btn-salvar" @click="beforeSave">Salvar</a>
                <licitacao-fornecedor-acoes-enviar @atualizarProposta="atualizarProposta"
                                                   :moeda-selecionada-id="this.moedaSelecionada ? this.moedaSelecionada.id : null"
                                                   v-if="!isPropostaEnviada && propostaResumo.podeEnviar"/>
            </div>
        </div>

        <licitacao-fornecedor-termos v-if="exibirModalTermo && isFornecedorAprovado"
                                     @concluido="finalizarAceiteTermos"
                                     @fechar="exibirModalTermo = false"/>

        <az-confirm @onConfirm="exibirModalInfoPropostaEnviada = false"
                    @onDecline="exibirModalInfoPropostaEnviada = false"
                    v-if="exibirModalInfoPropostaEnviada" :maxWidth=450 label-confirm="Ok" label-decline="Cancelar">
            Para alterar o a declaração é necessário cancelar o envio da proposta, após a alteração a proposta deve ser
            ENVIADA novamente.
        </az-confirm>
        <az-confirm v-if="mostrarModalAlertaGrupos" :maxWidth=450
                    label-confirm="Ok" label-decline=""
                    @onConfirm="fecharModalAlertaLotes">
            <div class="texto-modal-alerta-lotes">
                <v-icon color="#FFD22D">warning</v-icon>
                <label>
                    Atenção, senhores licitantes: O valor unitário por lote, corresponde ao valor total de todos os
                    itens que compõem o lote.
                </label>
            </div>
        </az-confirm>
        <az-confirm @onConfirm="salvar" @onDecline="exibirModalInfoValorZerado = false"
                    v-if="exibirModalInfoValorZerado" :maxWidth=450 label-confirm="Ok" label-decline="Cancelar">
            <div class="texto-modal-alerta-lotes">
                <v-icon color="#FFD22D">warning</v-icon>
                <label>
                    Atenção: Sua proposta possui itens com valor 0,00. Deseja salvar mesmo assim?
                </label>
            </div>
        </az-confirm>
    </div>
</template>

<script>
import {actionTypes, exceptions, mutationTypes, tiposLicitacao} from '@/commons/constants'
import {mapActions, mapMutations, mapState} from 'vuex'
import accounting from 'accounting'
import _ from 'lodash'
import validadorFormulario from './licitacao-fornecedor-proposta-validador'
import cabecalhoTabela from './licitacao-fornecedor-proposta-cabecalho-tabela'
import LicitacaoFornecedorPropostaItem from './LicitacaoFornecedorPropostaItem'
import LicitacaoFornecedorAcoesEnviar from '../acoes/LicitacaoFornecedorAcoesEnviar'
import LicitacaoFornecedorTermos from '../termos/LicitacaoFornecedorTermos'
import LicitacaoMensagemCerca from "@/views/licitacao/detalhe/fornecedor/termos/LicitacaoMensagemCerca.vue";

export default {
    name: 'LicitacaoFornecedorProposta',
    components: {
        LicitacaoMensagemCerca,
        LicitacaoFornecedorPropostaItem, LicitacaoFornecedorAcoesEnviar, LicitacaoFornecedorTermos
    },
    data() {
        return {
            indiceHeaderValorReferencia: 6,
            licitacaoId: undefined,
            exibirModalTermo: false,
            exibirModalInfoPropostaEnviada: false,
            aguardarSalvamentoUnitario: false,
            aguardandoParaSalvarGeral: false,
            mostrarModalAlertaGrupos: false,
            formatacaoPreco: false,
            prazoValidade: null,
            prazoEntrega: null,
            moedaSelecionadaId: null,
            moedasOpcoes: [],
            moedasDisponiveis: null,
            moedaSelecionada: {},
            pregaoUtilizaMoedaEstrangeira: null,
            fornecedorId: this.$store.state.loki.user.domainId,
            headers: [],
            dataReady: false,
            exibirModalInfoValorZerado: false,
        }
    },
    computed: {
        isPropostaEnviada() {
            return this.propostaResumo.enviada
        },
        isMenorPreco() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
        },
        isMaiorDesconto() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
        },
        isMaiorOferta() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MO
        },
        isMelhorTecnica() {
            return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MTC
        },
        isFornecedorAprovado() {
            return this.loki.user.domainId !== null
        },
        tablePaginationDropdown() {
            return [20, 30, 50]
        },
        isGrupo() {
            return this.propostaResumo.possuiGrupo
        },
        ehModalidadeLeilao() {
            return this.licitacao && this.licitacao.modalidade && this.licitacao.modalidade.includes('LEILÃO')
        },
        ...mapState({
            loki: state => state.loki,
            licitacao: state => state.licitacao,
            propostaResumo: state => state.propostaResumo,
            termoAceiteProposta: state => state.termoAceiteProposta,
            licitacaoPropostaItens: state => state.licitacaoPropostaItens,
            possuiItemComPeriodicidade: state => state.possuiItemComPeriodicidade
        })
    },
    beforeRouteLeave(to, from, next) {
        this.habilitarLoadingGlobal()
        this.resetUploadedFiles()
        next()
    },
    async mounted() {
        this.desabilitarLoadingGlobal()
        this.setLicitacaoId(this.$route.params.id)
        this.verificaSeUtilizaMoedaEstrangeira()
        await this.buscarLicitacao(this.licitacaoId)
        await this.sincronizarProposta()
        await this.buscarTodosItens()
        await this.setPrazo()
        if (this.pregaoUtilizaMoedaEstrangeira) {
            await this.buscarMoedaSelecionadaFornecedor(this.licitacaoId, this.fornecedorId)
            await this.buscarMoedasDisponiveisPregao(this.licitacaoId)
        }
        this.initializeHeaders()
        setTimeout(() => {
            this.carregarModalAlertaGrupos();
        }, 50);
        this.dataReady = true;
    },
    methods: {
        initializeHeaders() {
            let defaultHeaders = [...cabecalhoTabela]

            if (this.licitacao.ehPerfilComprasBR) {
                defaultHeaders[1].text = 'Lote/Item'
            } else {
                defaultHeaders[1].text = 'Tipo'
            }

            const indiceHeaderValorReferencia = 7
            const indiceHeaderQuantidadeProposta = 6

            if (!this.ehAmparoLei14133Art82()) {
                defaultHeaders.splice(indiceHeaderQuantidadeProposta, 1)
            }

            if (this.isMenorPreco) {
                if (!this.licitacao.mostrarValorReserva) {
                    defaultHeaders.splice(indiceHeaderValorReferencia, 1)
                }
            } else if (this.isMaiorDesconto) {
                let indiceHeaderValorRefDesconto = 7
                let indiceHeaderValorDesconto = 8
                let indiceHeaderValorTotal = 9
                if (!this.licitacao.mostrarValorReserva) {
                    defaultHeaders.splice(indiceHeaderValorReferencia, 1)
                    indiceHeaderValorRefDesconto = 6
                    indiceHeaderValorDesconto = 7
                    indiceHeaderValorTotal = 8
                }

                defaultHeaders.splice(indiceHeaderValorRefDesconto, 0, {
                    text: 'Val. Ref. Desconto (%)',
                    align: 'right',
                    sortable: false,
                    width: '100px'
                })
                defaultHeaders[indiceHeaderValorDesconto] = {
                    text: 'Val. Desconto (%)',
                    align: 'center',
                    sortable: false,
                    width: '100px'
                }
                if (this.isPropostaEnviada) {
                    defaultHeaders[indiceHeaderValorTotal] = {
                        text: 'Val. Total',
                        align: 'center',
                        sortable: false,
                        width: '100px'
                    }
                }
            } else if (this.isMaiorOferta) {
                let indiceHeaderValorUnitario = 7
                let indiceHeaderValorTotal = 8
                if (!this.licitacao.mostrarValorReserva) {
                    defaultHeaders.splice(indiceHeaderValorReferencia, 1)
                    indiceHeaderValorUnitario = 6
                    indiceHeaderValorTotal = 7
                }

                defaultHeaders[indiceHeaderValorUnitario] = {
                    text: 'Oferta',
                    align: 'center',
                    sortable: false,
                    width: '150px'
                }

                defaultHeaders.splice(indiceHeaderValorTotal, 1)
            } else if (this.isMelhorTecnica) {
                defaultHeaders.splice(4, 2)
                defaultHeaders.splice(5, 3)
            }

            if (this.moedaSelecionada.existeMoedaSelecionada) {
                defaultHeaders.push({
                    text: 'Currency conversion',
                    align: 'right',
                    sortable: false,
                    value: 'valorTotal',
                    width: '100px'
                })
            }

              if (this.ehModalidadeLeilao) {
                defaultHeaders.splice(2, 0, {
                  text: 'Imagens',
                  align: 'left',
                  sortable: false,
                  width: '60px'
                })
              }

              if (this.possuiItemComPeriodicidade) {
                this.inserirHeaderPeriodicidade(defaultHeaders)
              }

              this.headers = defaultHeaders
            },
            inserirHeaderPeriodicidade(headers) {
                const headerPeriodicidade = {
                    text: 'Periodicidade',
                    align: 'center',
                    sortable: false,
                    width: '120px'
                }
                const indiceValorTotal = headers.findIndex(header => header.text === 'Val. Total')
                if (indiceValorTotal >= 0) {
                    headers.splice(indiceValorTotal, 0, headerPeriodicidade)
                    return
                }

                const indiceAnexos = headers.findIndex(header => header.text === 'Anexos')
                if (indiceAnexos >= 0) {
                    headers.splice(indiceAnexos, 0, headerPeriodicidade)
                    return
                }

                headers.push(headerPeriodicidade)
            },
            finalizarAceiteTermos(){
              this.$emit('termosAceitos')
            },
            async atualizarProposta(){
              await this.buscarTodosItens()
            },
            async atualizarPrazo() {
              const licitacaoId = this.licitacaoId
              const fornecedorId = this.propostaResumo.fornecedor.fornecedorId
              const prazoValidade = this.prazoValidade
              const prazoEntrega = this.prazoEntrega

            await this.$store.dispatch(actionTypes.ATUALIZAR_PROPOSTA_PRAZO, {
                licitacaoId,
                fornecedorId,
                prazoValidade,
                prazoEntrega,
            })
        },
        atualizarObjetosItensProposta() {
            const novaListaItens = _.concat(this.licitacaoPropostaItens)
            // this.licitacaoPropostaItens = []
            // novaListaItens.forEach(item => this.licitacaoPropostaItens.push(_.clone(item)))
            this.$store.commit(mutationTypes.SET_LICITACAO_PROPOSTA_ITENS, _.cloneDeep(novaListaItens))
        },
        async buscarTodosItens() {
            this.setMensagemLoading('Carregando itens da licitação...')
            this.habilitarLoadingGlobal()
            this.formatacaoPreco = false;
            await this.buscarLicitacaoPropostaItens(this.licitacaoId)
            this.carregarQuantidadeFornecedores()
            this.formatarPrecoItens()
            this.desabilitarLoadingGlobal()
        },
        carregarQuantidadeFornecedores() {
            this.licitacaoPropostaItens.forEach(item => {
                if (this.ehAmparoLei14133Art82() && !this.esconderCamposProposta(item) && !item.quantidadeProposta) {
                    item.quantidadeProposta = item.quantidade
                }
            })
        },
        esconderCamposProposta(item) {
            return this.isPropostaEnviada || (item.tipoNegociacao === 'Exclusivo' && !this.isFornecedorMicroEmpresa)
        },
        isFornecedorMicroEmpresa() {
            return this.termoAceiteProposta && this.termoAceiteProposta.microEmpresa === 'S'
        },
        formatarPrecoItens() {
            if (!this.isMenorPreco) {
                this.licitacaoPropostaItens.forEach(item => {
                    if (item.preco) {
                        item.preco = accounting.formatNumber(item.preco, item.casasDecimais, '.', ',')
                    }
                })
            }
            this.formatacaoPreco = true;
        },
        montarPayload() {
            const payload = {
                propostaItemDTOList: [],
                moedaEstrangeiraSelecionada: this.moedaSelecionada.id,
                valorCambioMoedaEstrangeiraSelecionada: this.moedaSelecionada.cotacaoVenda
            }
            this.licitacaoPropostaItens.forEach(licitacaoPropostaItem => {
                payload.propostaItemDTOList.push(Object.assign({}, licitacaoPropostaItem, {
                    preco: (licitacaoPropostaItem.preco === null || (!this.isMenorPreco && licitacaoPropostaItem.preco.trim() === '')) ?
                        null : accounting.unformat(licitacaoPropostaItem.preco, ','),
                    marca: (this.ehModalidadeLeilao || !licitacaoPropostaItem.marca || licitacaoPropostaItem.marca.trim() === '') ?
                        null : licitacaoPropostaItem.marca,
                    modelo: this.ehModalidadeLeilao ? null : licitacaoPropostaItem.modelo
                }))
            })
            return payload
        },
        async salvar() {
            this.exibirModalInfoValorZerado = false

            if (this.aguardarSalvamentoUnitario) {
                this.aguardandoParaSalvarGeral = true
                return
            }
            try {
                if (!validadorFormulario.validar(this.licitacaoPropostaItens, this.isMenorPreco, this.ehAmparoLei14133Art82(), this.ehModalidadeLeilao)) {
                    this.atualizarObjetosItensProposta()
                    this.mostrarNotificacaoErro('Existem lotes com informações incompletas ou inválidas, verifique.')
                    return
                }

                const payload = this.montarPayload()
                this.habilitarLoadingGlobal()

                await this.atualizarPrazo()

                this.setMensagemLoading('Salvando dados da proposta...')
                await this.atualizarPropostaItens({licitacaoId: this.licitacaoId, payload})
                this.mostrarNotificacaoSucessoDefault()
                await this.sincronizarProposta()
                await this.buscarTodosItens()
                this.desabilitarLoadingGlobal()
            } catch (e) {
                const exception = e.response ? exceptions[e.response.data.exception] : undefined
                if (exception && exception.ignorarNotificacaoDefault) {
                    this.mostrarMensagemErro(e.response.data.message)
                }
                this.desabilitarLoadingGlobal()
            }
        },
        setLicitacaoId(licitacaoId) {
            this.licitacaoId = licitacaoId
        },
        async sincronizarProposta() {
            this.setMensagemLoading('Sincronizando proposta...')
            await this.buscarPropostaResumo(this.licitacaoId)
        },
        abrirModalTermo() {
            if (this.isPropostaEnviada) {
                this.exibirModalInfoPropostaEnviada = true
            } else {
                this.exibirModalTermo = true
            }
        },
        ehAmparoLei14133Art82() {
            return this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
        },
        async atualizarLoteItemProposta(payload) {
            this.aguardarSalvamentoUnitario = true
            await this.atualizarItemProposta(payload);
            this.aguardarSalvamentoUnitario = false
        },
        carregarModalAlertaGrupos() {
            if (!this.isPropostaEnviada && this.isGrupo) {
                this.mostrarModalAlertaGrupos = true
            } else {
                this.mostrarModalAlertaGrupos = false
            }
        },
        fecharModalAlertaLotes() {
            this.mostrarModalAlertaGrupos = false
        },
        async setPrazo() {
            if (!this.propostaResumo.propostaPrazo) {
                await this.buscarPropostaResumo(this.licitacaoId)
            }
            this.prazoValidade = this.propostaResumo.propostaPrazo.prazoValidade
            this.prazoEntrega = this.propostaResumo.propostaPrazo.prazoEntrega
        },
        permitirApenasNumeros(event) {
            const charCode = event.charCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        async buscarMoedasDisponiveisPregao(licitacaoId) {
            try {
                const response = await this.buscarMoedasDisponiveisPregaoFornecedor(licitacaoId)

                this.moedasDisponiveis = response.itens.map((item) => {
                    return {
                        id: item.idMoedaEstrangeira,
                        descricao: item.descricaoMoeda,
                        sigla: item.sigla,
                        cotacaoVenda: item.cotacao ? item.cotacao.cotacaoVenda : null,
                        dataReferencia: item.cotacao ? item.cotacao.dataReferencia : null
                    }
                })

                this.moedasOpcoes = this.moedasDisponiveis.map((moeda) => moeda.descricao)
            } catch (error) {
                console.error('Erro ao buscar moedas disponíveis:', error)
            }
        },
        async buscarMoedaSelecionadaFornecedor(licitacaoId, fornecedorId) {
            try {
                const response = await this.buscarMoedaSelecionadaPeloFornecedor({licitacaoId, fornecedorId})

                if (response.idMoedaEstrangeira) {
                    this.moedaSelecionada = {
                        id: response.idMoedaEstrangeira,
                        descricao: response.descricaoMoeda,
                        sigla: response.sigla,
                        cotacaoVenda: response.cotacao ? response.cotacao.cotacaoVenda : null,
                        dataReferencia: response.cotacao ? response.cotacao.dataReferencia : null
                    }

                    this.moedaSelecionadaId = this.moedaSelecionada.id
                    this.moedaSelecionada.existeMoedaSelecionada = true
                }
            } catch (error) {
                console.error('Erro ao buscar moedas disponíveis:', error)
            }
        },
        onMoedaSelecionada() {
            this.moedaSelecionada = this.moedasDisponiveis.find(
                (moeda) => moeda.id === this.moedaSelecionadaId
            )
            if (this.moedaSelecionada.id) {
                this.moedaSelecionada.dataReferencia = this.formatarData(this.moedaSelecionada.dataReferencia)
                this.moedaSelecionada.existeMoedaSelecionada = true

                const headerExists = this.headers.some(header => header.text === 'Currency conversion');
                if (!headerExists) {
                    this.headers.push({
                        text: 'Currency conversion',
                        align: 'right',
                        sortable: false,
                        value: 'valorTotal',
                        width: '100px'
                    });
                }
            }
        },
        verificaSeUtilizaMoedaEstrangeira() {
            this.pregaoUtilizaMoedaEstrangeira = this.licitacao.utilizaMoedaEstrangeira
        },
        formatarData(timestamp) {
            if (!timestamp) return ''

            const data = new Date(timestamp)
            const dia = data.getDate().toString().padStart(2, '0')
            const mes = (data.getMonth() + 1).toString().padStart(2, '0')
            const ano = data.getFullYear()

            return `${dia}/${mes}/${ano}`
        },
        beforeSave() {
            const hasValorZerado = this.licitacaoPropostaItens.some(licitacaoPropostaItem => {
                if (this.isMenorPreco) {
                    return accounting.unformat(licitacaoPropostaItem.preco, ',') === 0
                        && licitacaoPropostaItem.preco !== null
                } else {
                    return accounting.unformat(licitacaoPropostaItem.preco, ',') === 0
                        && licitacaoPropostaItem.preco !== null
                        && licitacaoPropostaItem.preco.trim() !== ''
                }
            })
            if (hasValorZerado) {
                this.exibirModalInfoValorZerado = true
            } else {
                this.salvar()
            }
        },
        ...mapActions([
            actionTypes.ATUALIZAR_PROPOSTA_ITENS,
            actionTypes.BUSCAR_LICITACAO,
            actionTypes.BUSCAR_LICITACAO_PROPOSTA_ITENS,
            actionTypes.BUSCAR_PROPOSTA_RESUMO,
            actionTypes.ATUALIZAR_ITEM_PROPOSTA,
            actionTypes.ATUALIZAR_PROPOSTA_PRAZO,
            actionTypes.BUSCAR_MOEDAS_DISPONIVEIS_PREGAO_FORNECEDOR,
            actionTypes.BUSCAR_MOEDA_SELECIONADA_FORNECEDOR
        ]),
        ...mapMutations([
            mutationTypes.MOSTRAR_MENSAGEM_ERRO
        ])
    },
    watch: {
        aguardarSalvamentoUnitario: {
            handler(novoValor) {
                if (novoValor === false && this.aguardandoParaSalvarGeral) {
                    this.aguardandoParaSalvarGeral = false
                    this.salvar()
                }
            },
            deep: true
        }
    }
};
</script>

<style lang="stylus">

.li-fornecedor-proposta
    .btn-salvar
        height 36px
        text-transform uppercase
        padding 8px 15px !important
        margin 6px 8px

    .info-termo
        a
            text-decoration none
            position relative
            color #c6762b !important

            span
                font-weight bold
                color #808080
                padding-right 15px


@media (max-width: 450px)
    .li-fornecedor-proposta
        .az-table-list
            td:nth-of-type(1):before {
                content "Lote/Item:"
            }

            td:nth-of-type(2):before {
                content "Exclusivo:"
            }

            td:nth-of-type(3):before {
                content "Descrição:"
            }

            td:nth-of-type(4):before {
                content "Quantidade:"
            }

            td:nth-of-type(5):before {
                content "Marca:"
            }

            td:nth-of-type(6):before {
                content "Modelo:"
            }

            td:nth-of-type(7):before {
                content "Val. Ref.:"
            }

            td:nth-of-type(8):before {
                content "Val. Unit.:"
            }

            td:nth-of-type(9):before {
                content "Val. Total:"
            }

            td:nth-of-type(10):before {
                content "Anexos:"
            }

        .anexos
            .v-menu
                display flex !important

        .az-table-list td
            text-align left !important
            padding 5px 10px !important

        .status
            span
                color #777777

                i
                    display none

        .status-active
            a
                text-decoration none
                position relative
                top -5px
                color #c6762b !important

                i
                    position relative
                    top 5px
                    font-size 26px
                    color #c6762b !important
                    text-decoration none

.texto-modal-alerta-lotes
    text-align justify

.campo-prazo-validade {
    max-width: 110px;
}

.aviso-participacao {
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 1rem;
    margin-bottom: 16px;
    color: #555;
}

.aviso-periodicidade {
    align-items: flex-start;
    align-self: flex-start;
    border: 1px solid #80b9eb;
    border-radius: 4px;
    color: #31708f;
    display: flex;
    font-size: 11px;
    line-height: 1.4;
    margin: 8px 4px 0 auto;
    width: 550px;
    padding: 10px 12px;

    &__icone {
        color: #1687d4;
        font-size: 21px;
        margin: 0 10px 0 0;
    }

    strong {
        color: #0067b1;
        display: block;
        font-size: 12px;
        margin-bottom: 2px;
    }

    p {
        margin: 0;
    }
}

.proposta-periodicidade-contexto {
    display: flex;
    min-height: 96px;
}

.proposta-prazos {
    flex: 0 0 110px;
}

.legenda-periodicidade {
    align-items: flex-start;
    color: #555;
    display: flex;
    font-size: 11px;
    line-height: 1.45;
    margin-top: 12px;

    .v-icon {
        color: #1687d4 !important;
        font-size: 16px;
        margin: 0 4px 0 0;
    }

    &__titulo {
        color: #0067b1;
    }

    div div + div {
        margin-top: 1px;
    }
}

@media (max-width: 900px) {
    .proposta-periodicidade-contexto {
        display: block;
    }

    .aviso-periodicidade {
        margin-left: 0;
        max-width: none;
        min-width: 0;
        width: auto;
    }
}
</style>
